import { UiModuleTheme, ThemeType } from "./";

const darkTheme: UiModuleTheme = {
  type: ThemeType.DARK,
  bodyBackground: "rgba(19, 19, 26, 1)",
  successColor: "rgba(67, 181, 129, 1)",
  appBarBackground: "rgb(28, 28, 36, 1)",
  sideBarBackground: "rgba(28, 28, 36, 1)",
  skeletonBg: "rgba(5, 5, 6, 1)",
  material: {
    primary: "rgba(34, 169, 212, 1)",
    secondary: "rgba(250, 166, 26, 1)",
    error: "rgba(240, 71, 71, 1)",
    background: "rgba(28, 28, 36, 1)",
    surface: "rgba(28, 28, 36, 1)",
    onPrimary: "rgba(255,255,255,.87)",
    onSecondary: "rgba(0, 0, 0, 0.87)",
    onSurface: "rgba(255,255,255,.87)",
    onError: "rgba(255, 255, 255, 1)",
    textPrimaryOnBackground: "rgba(255, 255, 255, 1)",
    textSecondaryOnBackground: "rgba(255, 255, 255, 0.7)",
    textHintOnBackground: "rgba(142, 146, 151, 1)",
    textDisabledOnBackground: "rgba(185, 187, 190, 1)",
    textIconOnBackground: "rgba(255, 255, 255, 0.5)",
    textPrimaryOnLight: "rgba(0, 0, 0, 0.87)",
    textSecondaryOnLight: "rgba(0, 0, 0, 0.54)",
    textHintOnLight: "rgba(0, 0, 0, 0.38)",
    textDisabledOnLight: "rgba(107, 107, 107, 1)",
    textIconOnLight: "rgba(0, 0, 0, 0.38)",
    textPrimaryOnDark: "rgba(255, 255, 255, 1)",
    textSecondaryOnDark: "rgba(185, 187, 190, 1)",
    textHintOnDark: "rgba(185, 187, 190, 1)",
    textDisabledOnDark: "rgba(255, 255, 255, 0.5)",
    textIconOnDark: "rgba(255, 255, 255, 0.5)",
  },
};

export default darkTheme;
